import { Spinner, makeStyles, tokens } from '@fluentui/react-components';

type SpinnerSize = 'tiny' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge';

interface LoadingSpinnerProps {
  label?: string;
  size?: SpinnerSize;
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXL,
    width: '100%',
  },
});

export function LoadingSpinner({
  label = 'Loading...',
  size = 'medium',
}: LoadingSpinnerProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size={size} label={label} />
    </div>
  );
}
